import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import React from 'react';

import {
  CriteriaTextWrapper,
  MatchStyledText,
  StyledFlexWithGapAndNoWrap,
} from './SmartChoiceBreakDown.styles';

interface NotAMatchTextProps {
  text: string;
  StartIcon?: React.ReactNode;
  EndIcon?: React.ReactNode;
  noIcon?: boolean;
}
export const NotAMatchText = ({
  text,
  StartIcon,
  EndIcon,
  noIcon,
}: NotAMatchTextProps) => (
  <CriteriaTextWrapper data-testid={`not-a-match-text-${text}`}>
    <StyledFlexWithGapAndNoWrap direction="row">
      {!noIcon && (
        <IconSymbol
          color="#990000"
          data-testid="not-a-match-icon"
          icon="do_not_disturb"
        />
      )}
      {StartIcon && <React.Fragment>{StartIcon}</React.Fragment>}
    </StyledFlexWithGapAndNoWrap>
    {text && (
      <CriteriaTextWrapper>
        <MatchStyledText
          css={noIcon ? { paddingLeft: '26px' } : {}}
          data-testid="not-a-match-text-content"
        >
          {text}
        </MatchStyledText>
        {EndIcon && <React.Fragment>{EndIcon}</React.Fragment>}
      </CriteriaTextWrapper>
    )}
  </CriteriaTextWrapper>
);
